import Menu from 'components/Menu';
import { type FC, useMemo } from 'react';
import { Translation } from 'utils/translations';

import styles from './ResponsibleGamingMenu.module.scss';

const MENU_ITEMS = [
  {
    id: 'responsible_gaming',
    label: 'responsible_gaming',
    link: '/account/responsible-gaming',
    icon: 'security-time.bold',
  },
];

const ResponsibleGamingMenu: FC = () => {
  const items = useMemo(
    () =>
      MENU_ITEMS.map((item) => ({
        id: item.id,
        label: <Translation message={item.label} />,
        link: item.link,
        icon: item.icon,
      })),
    [],
  );

  return (
    <Menu
      items={items}
      dataId="responsible-gaming"
      className={styles.wrapper}
    />
  );
};

export default ResponsibleGamingMenu;
